<template>
  <div ref="rankContainerRef" class="rank-container d-flex flex-row align-items-end" :style="rankContainerStyle">

    <!-- Second place -->
    <div class="d-flex flex-column align-items-center" :style="rank2ContainerStyle">
      <img v-if="isSatset" src="@/assets/img/events/satset/crown-2.png" :style="rank2BadgeStyle" class="rank-img" alt=""/>
      <img v-else src="../../assets/img/events/rank_2.svg" :style="rank2BadgeStyle" class="rank-img" alt=""/>
      <!-- Avatar or placeholder -->
      <div :class="`avatar-container ${isSatset ? 'mt-2' : ''}`" :style="rank2AvatarContainerStyle">
        <template v-if="rank2User">
          <img v-if="rank2User.avatar_url" :src="getImageUrl(rank2User.avatar_url)"
               class="rank2-avatar" :style="rank2AvatarStyle" alt=""/>
          <img v-else src="@/assets/img/logo.png" class="rank2-avatar" :style="rank2AvatarStyle" :class="fillParent ? 'p-3' : 'p-2'" alt=""/>
        </template>
        <template v-else>
          <img src="@/assets/img/logo.png" class="rank2-avatar" :style="rank2AvatarStyle" :class="fillParent ? 'p-3' : 'p-2'" alt=""/>
        </template>
        <!-- Treasure hunt frame overlay -->
        <img v-if="isTreasureHuntEvent" src="@/assets/img/events/treasure-hunt/rank-2.png"
             class="rank-frame-overlay" :style="rank2FrameStyle" alt=""/>
      </div>
      <div :style="userInfoContainerStyle">
        <!-- Username or placeholder dash -->
        <p v-if="rank2User" class="username" :style="usernameStyle">
          {{ rank2User.username }}
        </p>
        <p v-else class="placeholder-text username" :style="usernameStyle">—</p>
        <!-- ID or placeholder dash -->
        <p v-if="rank2User" class="user-id" :style="userIdStyle">
          ID: {{ rank2User.uuid }}
        </p>
        <p v-else class="placeholder-text user-id" :style="userIdStyle">—</p>
      </div>
      <!-- Bottom podium bar -->
      <div class="rank2-bottom mt-1" :style="rank2PodiumStyle"/>
    </div>

    <!-- First place -->
    <div class="d-flex flex-column align-items-center" :style="rank1ContainerStyle">
      <img v-if="isSatset" src="@/assets/img/events/satset/crown-1.png" :style="rank1BadgeStyle"  class="rank-img" alt=""/>
      <img v-else src="../../assets/img/events/rank_1.svg" :style="rank1BadgeStyle" class="rank-img" alt=""/>
      <!-- Avatar or placeholder -->
      <div :class="`avatar-container ${isSatset ? 'mt-2' : ''}`" :style="rank1AvatarContainerStyle">
        <template v-if="rank1User">
          <img v-if="rank1User.avatar_url" :src="getImageUrl(rank1User.avatar_url)"
               class="rank1-avatar" :style="rank1AvatarStyle" alt=""/>
          <img v-else src="@/assets/img/logo.png" class="rank1-avatar"
               :style="rank1AvatarStyle" :class="fillParent ? 'p-3' : 'p-2'" alt=""/>
        </template>
        <template v-else>
          <img src="@/assets/img/logo.png" class="rank1-avatar" :style="rank1AvatarStyle" :class="fillParent ? 'p-3' : 'p-2'" alt=""/>
        </template>
        <!-- Treasure hunt frame overlay -->
        <img v-if="isTreasureHuntEvent" src="@/assets/img/events/treasure-hunt/rank-1.png"
             class="rank-frame-overlay" :style="rank1FrameStyle" alt=""/>
      </div>
      <div :style="userInfoContainerStyle">
        <!-- Username or placeholder -->
        <p v-if="rank1User" class="username" :style="usernameStyle">
          {{ rank1User.username }}
        </p>
        <p v-else class="placeholder-text username" :style="usernameStyle">—</p>
        <!-- ID or placeholder -->
        <p v-if="rank1User" class="user-id" :style="userIdStyle">
          ID: {{ rank1User.uuid }}
        </p>
        <p v-else class="placeholder-text user-id" :style="userIdStyle">—</p>
      </div>
      <!-- Bottom podium bar -->
      <div class="rank1-bottom mt-1" :style="rank1PodiumStyle"/>
    </div>

    <!-- Third place -->
    <div class="d-flex flex-column align-items-center" :style="rank3ContainerStyle">
      <!-- Badge icon always visible -->
      <img v-if="isSatset" src="@/assets/img/events/satset/crown-3.png" :style="rank3BadgeStyle" class="rank-img" alt=""/>
      <img v-else src="../../assets/img/events/rank_3.svg" :style="rank3BadgeStyle" class="rank-img" alt=""/>
      <!-- Avatar or placeholder -->
      <div :class="`avatar-container ${isSatset ? 'mt-2' : ''}`" :style="rank3AvatarContainerStyle">
        <template v-if="rank3User">
          <img v-if="rank3User.avatar_url" :src="getImageUrl(rank3User.avatar_url)"
               class="rank3-avatar" :style="rank3AvatarStyle" alt=""/>
          <img v-else src="@/assets/img/logo.png" class="rank3-avatar"
               :style="rank3AvatarStyle" :class="fillParent ? 'p-3' : 'p-2'" alt=""/>
        </template>
        <template v-else>
          <img src="@/assets/img/logo.png" class="rank3-avatar" :style="rank3AvatarStyle" :class="fillParent ? 'p-3' : 'p-2'" alt=""/>
        </template>
        <!-- Treasure hunt frame overlay -->
        <img v-if="isTreasureHuntEvent" src="@/assets/img/events/treasure-hunt/rank-3.png"
             class="rank-frame-overlay" :style="rank3FrameStyle" alt=""/>
      </div>
      <div :style="userInfoContainerStyle">
        <!-- Username or placeholder -->
        <p v-if="rank3User" class="username" :style="usernameStyle">
          {{ rank3User.username }}
        </p>
        <p v-else class="placeholder-text username" :style="usernameStyle">—</p>
        <!-- ID or placeholder -->
        <p v-if="rank3User" class="user-id" :style="userIdStyle">
          ID: {{ rank3User.uuid }}
        </p>
        <p v-else class="placeholder-text user-id" :style="userIdStyle">—</p>
      </div>
      <!-- Bottom podium bar -->
      <div class="rank3-bottom mt-1" :style="rank3PodiumStyle"/>
    </div>
  </div>
</template>

<script>
import { urlImage } from '@/helpers/common';
import { EVENT_TYPES } from "@/constants/constants";

export default {
  name: 'EventTopRanking',
  props: {
    eventType: {
      type: String,
      required: true
    },
    rank1User: {
      type: Object,
      default: null
    },
    rank2User: {
      type: Object,
      default: null
    },
    rank3User: {
      type: Object,
      default: null
    },
    isWideContainer: {
      type: Boolean,
      default: false
    },
    parentWidth: {
      type: Number,
      required: true
    },
    fillParent: {
      type: Boolean,
      default: false
    },
    isSatset: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isReferralEvent() {
      return this.eventType === EVENT_TYPES.TYPE_REFERRAL
    },
    isTreasureHuntEvent() {
      return this.eventType === EVENT_TYPES.TYPE_TREASURE_HUNT
    },
    rankContainerStyle() {
      let gap = this.fillParent ? 25 : 15
      if (this.isReferralEvent || this.isSatset) {
        gap = gap * 0.9
      }
      let backgroundImage = null
      if (this.isReferralEvent) {
        backgroundImage = this.fillParent
          ? `url(${new URL('@/assets/img/events/podium_referral_detail.png', import.meta.url)})`
          : `url(${new URL('@/assets/img/events/podium_referral.png', import.meta.url)})`
      } else if (this.isSatset) {
        backgroundImage = this.fillParent
          ? `url(${new URL('@/assets/img/events/satset/event-satset-rank-bg.png', import.meta.url)})`
          : `url(${new URL('@/assets/img/events/satset/event-satset-rank-banner-bg.png', import.meta.url)})`
      }
      const hasBg = this.isReferralEvent || this.isSatset
      return {
        gap: `${gap}px`,
        padding: hasBg ? `0 8px` : `0`,
        backgroundImage: backgroundImage,
        backgroundRepeat: hasBg ? "no-repeat" : null,
        backgroundPosition: hasBg ? "center bottom" : null,
        backgroundSize: hasBg ? (this.fillParent ? "95% auto" : "86% auto") : null
      };
    },
    userInfoContainerStyle() {
      const hasBackground = this.isReferralEvent || this.isSatset
      let width = this.fillParent ? this.parentWidth / 4.2 : 80
      let marginTop = hasBackground ? 5 : 3
      let paddingLeftRight = hasBackground ? 4 : 1
      let paddingTopBottom = hasBackground ? 2 : 1
      if (this.fillParent) {
        marginTop = marginTop * 3
        paddingLeftRight = paddingLeftRight * 1.2
        paddingTopBottom = paddingTopBottom * 2.5
      }
      return {
        'width': `${width}px`,
        'margin-top': `${marginTop}px`,
        'padding': `${paddingTopBottom}px ${paddingLeftRight}px`,
        'background-color': this.isReferralEvent ? '#FFD5F9' : (this.isSatset ? '#FFFFFF' : null),
        'border-radius': hasBackground ? '3px' : null,
        'border': this.isSatset ? '1px solid #002BB6' : null,
      };
    },
    usernameStyle() {
      let maxWidth = this.fillParent ? this.parentWidth / 4.1 : 76
      let fontSize = (this.isReferralEvent || this.isSatset) ? 9.6 : 10.6
      if (this.fillParent) {
        fontSize = fontSize + (this.parentWidth * 0.005)
      }
      let textColor = this.isReferralEvent ? '#991788' : (this.isSatset ? '#002BB6' : '#ECECEC')
      return {
        'max-width': `${maxWidth}px`,
        'font-size': `${fontSize}px`,
        'color': `${textColor}`
      };
    },
    userIdStyle() {
      let fontSize = (this.isReferralEvent || this.isSatset) ? 8.3 : 9.3
      if (this.fillParent) {
        fontSize = fontSize + (this.parentWidth * 0.005)
      }
      let textColor = this.isReferralEvent ? '#991788' : (this.isSatset ? '#4973FD' : '#ECECEC')
      return {
        'color': `${textColor}`,
        'font-size': `${fontSize}px`
      };
    },
    rank2ContainerStyle() {
      let width = this.fillParent ? (this.parentWidth / 4.2) : 73
      if (this.isTreasureHuntEvent) {
        width = width * 1.2
      }
      return { width: `${width}px`, };
    },
    rank2BadgeStyle() {
      const size = this.fillParent ? 36 : 22;
      const marginBottom = this.fillParent ? -18 : -11;
      const marginTop = 0;
      return {
        width: `${size}px`,
        height: `${size}px`,
        'margin-bottom': `${marginBottom}px`,
        'margin-top': `${marginTop}px`,
        display: this.isTreasureHuntEvent ? 'none' : 'block',
        'object-fit': 'contain',
      };
    },
    rank2AvatarContainerStyle() {
      let size = this.fillParent ? this.parentWidth / 4.3 : 73
      let width = size
      let height = size
      if (this.isTreasureHuntEvent) {
        size = size * 1.3
        width = size
        height = size * 168 / 182
      }
      return {
        position: 'relative',
        width: `${width}px`,
        height: `${height}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      };
    },
    rank2FrameStyle() {
      let size = this.fillParent ? this.parentWidth / 4.3 : 73
      let width = size
      let height = size
      if (this.isTreasureHuntEvent) {
        size = size * 1.3
        width = size
        height = size * 168 / 182
      }
      return {
        position: 'absolute',
        top: '0',
        left: '0',
        width: `${width}px`,
        height: `${height}px`,
        pointerEvents: 'none',
        zIndex: 10,
      };
    },
    rank2AvatarStyle() {
      let size = this.fillParent ? this.parentWidth / 4.3 : 73
      let marginBottom = 0
      if (this.isTreasureHuntEvent) {
        size = size * 0.88
        marginBottom = size * 0.15
      }
      return {
        width: `${size}px`,
        height: `${size}px`,
        border: this.isTreasureHuntEvent ? 'none' : null,
        marginBottom: `${marginBottom}px`
      };
    },
    rank2PodiumStyle() {
      let height, backgroundColor, borderRadius
      if (this.isReferralEvent) {
        height = this.fillParent ? 55 + (this.parentWidth * 0.21) : 55
        backgroundColor = 'transparent'
        borderRadius = '0'
      } else if (this.isTreasureHuntEvent) {
        height = 0.5 * (this.fillParent ? 30 : 14.5)
        backgroundColor = 'transparent'
        borderRadius = '0'
      } else if (this.isSatset) {
        height = this.fillParent ? 55 + (this.parentWidth * 0.21) : 55
        backgroundColor = 'transparent'
        borderRadius = '0'
      } else {
        height = this.fillParent ? 35 : 14.5
        backgroundColor = '#d5e4ff'
        borderRadius = this.fillParent ? 12 : 5
      }
      return {
        'height': `${height}px`,
        'background-color': `${backgroundColor}`,
        'borderRadius': `${borderRadius}px ${borderRadius}px 0 0`
      };
    },
    rank1ContainerStyle() {
      let width = this.fillParent ? (this.parentWidth / 3.8) : 80
      if (this.isTreasureHuntEvent) {
        width = width * 1.2
      }
      return { width: `${width}px` };
    },
    rank1BadgeStyle() {
      const size = this.fillParent ? 42 : 26;
      const marginBottom = this.fillParent ? -21 : -13;
      const marginTop = 0;
      return {
        width: `${size}px`,
        height: `${size}px`,
        'margin-bottom': `${marginBottom}px`,
        'margin-top': `${marginTop}px`,
        display: this.isTreasureHuntEvent ? 'none' : 'block',
        'object-fit': 'contain',
      };
    },
    rank1AvatarContainerStyle() {
      let size = this.fillParent ? this.parentWidth / 3.8 : 80
      let width = size
      let height = size
      if (this.isTreasureHuntEvent) {
        size = size * 1.8
        width = size
        height = size * 261 / 338
      }
      return {
        position: 'relative',
        width: `${width}px`,
        height: `${height}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    },
    rank1FrameStyle() {
      let size = this.fillParent ? this.parentWidth / 3.8 : 80
      let width = size
      let height = size
      if (this.isTreasureHuntEvent) {
        size = size * 1.8
        width = size
        height = size * 261 / 338
      }
      return {
        position: 'absolute',
        top: '0',
        left: '0',
        width: `${width}px`,
        height: `${height}px`,
        pointerEvents: 'none',
        zIndex: 10
      };
    },
    rank1AvatarStyle() {
      let size = this.fillParent ? this.parentWidth / 3.8 : 80;
      let marginBottom = 0;
      if (this.isTreasureHuntEvent) {
        size = size * 0.88
        marginBottom = -(size * 0.2)
      }
      return {
        width: `${size}px`,
        height: `${size}px`,
        border: this.isTreasureHuntEvent ? 'none' : null,
        marginBottom: `${marginBottom}px`
      };
    },
    rank1PodiumStyle() {
      let height, backgroundColor, borderRadius
      if (this.isReferralEvent) {
        height = this.fillParent ? 68 + (this.parentWidth * 0.3) : 68
        backgroundColor = 'transparent'
        borderRadius = '0'
      } else if (this.isTreasureHuntEvent) {
        height = 1.5 * (this.fillParent ? 60 : 25)
        backgroundColor = 'transparent'
        borderRadius = '0'
      } else if (this.isSatset) {
        height = this.fillParent ? 68 + (this.parentWidth * 0.3) : 68
        backgroundColor = 'transparent'
        borderRadius = '0'
      } else {
        height = this.fillParent ? 68 : 25
        backgroundColor = '#ffea95'
        borderRadius = this.fillParent ? 12 : 5
      }
      return {
        'height': `${height}px`,
        'background-color': `${backgroundColor}`,
        'borderRadius': `${borderRadius}px ${borderRadius}px 0 0`
      };
    },
    rank3ContainerStyle() {
      let width = this.fillParent ? (this.parentWidth / 4.5) : 66
      if (this.isTreasureHuntEvent) {
        width = width * 1.2
      }
      return { width: `${width}px` };
    },
    rank3BadgeStyle() {
      const size = this.fillParent ? 36 : 22;
      const marginBottom = this.fillParent ? -18 : -11;
      const marginTop = 0;
      return {
        width: `${size}px`,
        height: `${size}px`,
        'margin-bottom': `${marginBottom}px`,
        'margin-top': `${marginTop}px`,
        display: this.isTreasureHuntEvent ? 'none' : 'block',
        'object-fit': 'contain',
      };
    },
    rank3FrameStyle() {
      let size = this.fillParent ? this.parentWidth / 4.5 : 66;
      let width = size
      let height = size
      if (this.isTreasureHuntEvent) {
        size = size * 1.38
        width = size
        height = size * 155 / 182
      }
      return {
        position: 'absolute',
        top: '0',
        left: '0',
        width: `${width}px`,
        height: `${height}px`,
        pointerEvents: 'none',
        zIndex: 10
      };
    },
    rank3AvatarContainerStyle() {
      let size = this.fillParent ? this.parentWidth / 4.5 : 66;
      let width = size
      let height = size
      if (this.isTreasureHuntEvent) {
        size = size * 1.38
        width = size
        height = size * 155 / 182
      }
      return {
        position: 'relative',
        width: `${width}px`,
        height: `${height}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    },
    rank3AvatarStyle() {
      let size = this.fillParent ? this.parentWidth / 4.5 : 66;
      let marginBottom = 0
      if (this.isTreasureHuntEvent) {
        size = size * 0.86
        marginBottom = size * 0.1
      }
      return {
        width: `${size}px`,
        height: `${size}px`,
        border: this.isTreasureHuntEvent ? 'none' : null,
        marginBottom: `${marginBottom}px`
      };
    },
    rank3PodiumStyle() {
      let height, backgroundColor, borderRadius
      if (this.isReferralEvent) {
        height = this.fillParent ? 48 + (this.parentWidth * 0.16) : 48
        backgroundColor = 'transparent'
        borderRadius = '0'
      } else if (this.isTreasureHuntEvent) {
        height = 0.5 * (this.fillParent ? 16 : 8)
        backgroundColor = 'transparent'
        borderRadius = '0'
      } else if (this.isSatset) {
        height = this.fillParent ? 48 + (this.parentWidth * 0.16) : 48
        backgroundColor = 'transparent'
        borderRadius = '0'
      } else {
        height = this.fillParent ? 19 : 8
        backgroundColor = '#ffbe8e'
        borderRadius = this.fillParent ? 12 : 5
      }
      return {
        'height': `${height}px`,
        'background-color': `${backgroundColor}`,
        'borderRadius': `${borderRadius}px ${borderRadius}px 0 0`
      };
    }
  },
  methods: {
    getImageUrl(image) {
      return urlImage({ image });
    }
  }
};
</script>

<style scoped lang="scss">
.rank-container {
  /* Username styling */
  .username {
    font-weight: bold;
    text-align: center;
    /* enforce single line with “…” if it’s too long */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* User ID styling */
  .user-id {
    margin-top: -2px;
    font-weight: normal;
    text-align: center;
    /* enforce single line with “…” if it’s too long */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .placeholder-text {
    color: rgba(255, 255, 255, 0.5);
    font-style: italic;
  }

  .rank-img {
    z-index: 10;
  }

  .avatar-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rank-frame-overlay {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: 10;
  }

  .rank1-avatar,
  .rank2-avatar,
  .rank3-avatar {
    background-color: #E7F6F6;
    border-radius: 50%;
    display: block;
    z-index: 1;
  }

  .rank1-avatar {
    border: 3px solid #ffcf13;
  }

  .rank2-avatar {
    border: 3px solid #9ea8ba;
  }

  .rank3-avatar {
    border: 3px solid #dd722a;
  }

  .rank1-bottom,
  .rank2-bottom,
  .rank3-bottom {
    width: 100%;
  }
}
</style>
